import { createAction } from 'typesafe-actions'

import { Id, RoleType } from 'src/types'

import { GroupTreesActionTypes, ResponseDataRequests } from './types'

type Options = {
  assign_tree_id: Id
  page?: number
}

export const getGroupTrees = createAction(
  GroupTreesActionTypes.GET_GROUP_TREES,
  action =>
    (
      options: Options = {
        assign_tree_id: null,
        page: 1
      }
    ) =>
      action({ options })
)

export const getGroupTreesFailure = createAction(
  GroupTreesActionTypes.GET_GROUP_TREES_FAILURE,
  action => (message: string) => action({ message })
)

export const getGroupTreesSuccess = createAction(
  GroupTreesActionTypes.GET_GROUP_TREES_SUCCESS,
  action => (payload: ResponseDataRequests) => action(payload)
)

export const sendGroupTrees = createAction(
  GroupTreesActionTypes.SEND_GROUP_TREES,
  action =>
    (
      role_group_trees: [
        {
          assign_tree_id: Id
          delete: boolean
          role_type: RoleType
          user_id: Id
        }
      ]
    ) =>
      action({ role_group_trees })
)

export const sendGroupTreesFailure = createAction(
  GroupTreesActionTypes.SEND_GROUP_TREES_FAILURE,
  action => (message: string) => action({ message })
)

export const sendGroupTreesSuccess = createAction(
  GroupTreesActionTypes.SEND_GROUP_TREES_SUCCESS,
  action => () => action()
)
